import {
  Image as AntdImage,
  Upload,
  UploadFile,
} from 'antd/es'
import React, {
  useCallback,
  useMemo,
  useState,
} from 'react'

import { updateMessageDraft } from '@/redux/message-draft'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'

import { selectMessageDraft } from '../selector'


export interface PostPhotoListProps {
  creatorId: number
  fanUserId: number
}

export default function PostPhotoList({
  creatorId,
  fanUserId,
}: PostPhotoListProps) {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')

  const {
    medias,
  } = useAppSelector((state) =>
    selectMessageDraft(state, creatorId, fanUserId),
  )

  const dispatch = useAppDispatch()

  const fileList: UploadFile[] = useMemo(() => {
    return medias.map((media) => {
      const finalUrl = media.src?.split(',')[0] || ''
      return {
        uid: media.id.toString(),
        name: finalUrl,
        url: finalUrl,
      }
    })
  }, [medias])

  const handleRemove = useCallback(
    (file: UploadFile) => {
      void dispatch(
        updateMessageDraft({
          creatorId,
          fanUserId,
          changes: {
            medias: medias.filter((media) => media.id.toString() !== file.uid),
          },
        }),
      )
    },
    [creatorId, dispatch, fanUserId, medias],
  )

  const handlePreview = useCallback((file: UploadFile) => {
    setPreviewImage(file.url ?? '')
    setPreviewOpen(true)
  }, [])

  return (
    <>
      <Upload
        maxCount={9}
        listType="picture-card"
        onPreview={handlePreview}
        onRemove={handleRemove}
        fileList={fileList}
        customRequest={({ onSuccess }) => {
          if (onSuccess) {
            onSuccess('success')
          }
        }}
      ></Upload>
      {previewImage &&
        <AntdImage
          wrapperStyle={{ display: 'none' }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(''),
          }}
          src={previewImage}
        />
      }
    </>
  )
}
